import Button from 'common/components/button'
import { Edit as EditIcon } from 'common/icons'

import { Category } from '../api/queries/useGetCategoryDetailsQuery'

type Props = {
  categoryDetails: Category | undefined
  onEditDescription: () => void
}

const CategoryDetails = ({ categoryDetails, onEditDescription }: Props) => {
  if (!categoryDetails) {
    return null
  }

  const categoryName =
    categoryDetails.name ??
    (categoryDetails.ccnPath.length > 0
      ? categoryDetails.ccnPath[categoryDetails.ccnPath.length - 1]
      : 'Unknown Category')

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-4">
        <div className="flex justify-between items-start">
          <div className="flex flex-col gap-4 text-base-700">
            <h2 className="text-xl font-medium">{categoryName}</h2>
            <p className="text-xs">{categoryDetails.description}</p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              data-testid="edit-category-button"
              variant="icon"
              size="small"
              aria-label={`Edit category ${categoryName}`}
              onClick={onEditDescription}
            >
              <EditIcon size={6} isDefaultColor={false} />
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CategoryDetails
